<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <v-container grid-list-xl fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <h1 class="display-1">Installprice Management</h1>
            </v-flex>
            <v-flex xs6>
              <v-card>
                <v-container grid-list-xl fluid>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <h2 class="headline">Add Installprice</h2>
                      <v-text-field label="Type" v-model="type"></v-text-field>
                      <v-text-field label="Price" v-model="price"></v-text-field>
                      <v-btn large color="primary" v-if='selected' @click="updateInstallprice">Update Installprice</v-btn>
                      <v-btn large color="primary" v-else @click="addInstallprice">Add Installprice</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>

            <v-flex xs6>
              <v-card>
                <v-container grid-list-xl fluid>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-data-table :headers="headers" :items="installprices">
                        <template slot="items" slot-scope="props">
                          <td>{{ props.item.type }}</td>
                          <td>{{ props.item.price.toFixed(2) }} {{ props.item.type && props.item.type === 'Shutter' ? 'per panel' : '' }}{{ props.item.type && props.item.type.includes('Curtain') ? 'per metre of track (width)' : '' }}</td>
                          <td>
                            <button @click="editInstallprice(props.item._id)">Edit</button>
                          </td>
                        </template>
                    </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import InstallpriceService from '@/services/InstallpriceService.js'
export default {
  data () {
    return {
      headers: [
        { text: 'Type', value: 'type' },
        { text: 'Price', value: 'price' },
        { text: 'Actions', value: 'actions' }
      ],
      installprices: [],
      type: null,
      price: null,
      installShutter: null,
      installRollerBlind: null,
      installCurtain: null,
      selected: null
    }
  },
  mounted () {
    this.getInstallprices()
  },
  methods: {
    async getInstallprices () {
      const response = await InstallpriceService.getInstallprices()
      this.installprices = response.data.installprices
    },

    async addInstallprice () {
      await InstallpriceService.addInstallprice({
        type: this.type,
        price: this.price
      })

      this.type = null
      this.price = null

      this.getInstallprices()
    },
    async updateInstallprice () {
      await InstallpriceService.updateInstallprice({
        type: this.type,
        price: this.price,
        id: this.selected
      })

      this.selected = null
      this.type = null
      this.price = null

      this.getInstallprices()
    },

    async editInstallprice (id) {
      let response = await InstallpriceService.editInstallprice(id)
      this.selected = id
      this.type = response.data.installprice.type
      this.price = response.data.installprice.price
      // this.getInstallprices()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/InstallPrices.vue